// Mock agricultural products data with category-specific images
export const mockProducts = [
    // Coffee Products (5 items)
    {
        id: 1,
        farmerName: "Sidama Coffee Farmers Cooperative",
        productName: "Sidama Grade 1 Green Coffee Beans",
        category: "Coffee",
        origin: "Ethiopia - Sidama Region",
        processingMethod: "Washed",
        qualityLevel: "Grade 1",
        description: "Premium Sidama coffee beans from the birthplace of coffee. Hand-picked from farmers in the Sidama region. Known for its bright acidity, floral notes, and wine-like characteristics.",
        price: "$18.50/lb",
        image: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=600&q=80",
        available: 100,
        certification: "Fair Trade Certified",
        farmId: "SIDAMA-001",
        harvestDate: "2024-01-15",
        batchId: "BATCH-SIDAMA-2024-001",
        nftId: "NFT-SIDAMA-001",
        authenticityVerified: true,
        supplyChainSteps: [
            { step: "Farm Harvest", timestamp: "2024-01-15T06:00:00Z", location: "Sidama Region, Ethiopia", status: "completed" },
            { step: "Processing", timestamp: "2024-01-16T08:00:00Z", location: "Sidama Processing Plant", status: "completed" },
            { step: "Quality Control", timestamp: "2024-01-17T10:00:00Z", location: "Ethiopian Coffee Authority", status: "completed" },
            { step: "Export Preparation", timestamp: "2024-01-18T12:00:00Z", location: "Addis Ababa Port", status: "completed" }
        ]
    },
    {
        id: 2,
        farmerName: "Yirgacheffe Coffee Union",
        productName: "Yirgacheffe Grade 2 Arabica",
        category: "Coffee",
        origin: "Ethiopia - Yirgacheffe",
        processingMethod: "Washed",
        qualityLevel: "Grade 2",
        description: "Exceptional Yirgacheffe coffee with bright citrus and floral notes. Grown at high altitude (1,900m) with traditional processing methods.",
        price: "$16.75/lb",
        image: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=600&q=80",
        available: 75,
        certification: "Organic Certified",
        farmId: "YIRGA-002",
        harvestDate: "2024-02-10",
        batchId: "BATCH-YIRGA-2024-002",
        nftId: "NFT-YIRGA-002",
        authenticityVerified: true
    },
    {
        id: 3,
        farmerName: "Harrar Coffee Farmers",
        productName: "Harrar Longberry Natural",
        category: "Coffee",
        origin: "Ethiopia - Harrar Region",
        processingMethod: "Natural",
        qualityLevel: "Grade 3",
        description: "Traditional Harrar coffee with blueberry and wine notes. Natural processed beans with distinctive fruity characteristics.",
        price: "$14.25/lb",
        image: "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=600&q=80",
        available: 60,
        certification: "Direct Trade",
        farmId: "HARRAR-003",
        harvestDate: "2024-01-25",
        batchId: "BATCH-HARRAR-2024-003",
        nftId: "NFT-HARRAR-003",
        authenticityVerified: true
    },
    {
        id: 4,
        farmerName: "Guji Coffee Association",
        productName: "Guji Natural Process Coffee",
        category: "Coffee",
        origin: "Ethiopia - Guji Zone",
        processingMethod: "Natural",
        qualityLevel: "Premium",
        description: "Award-winning Guji coffee with complex fruit notes and clean finish. Natural processing enhances the inherent sweetness.",
        price: "$20.00/lb",
        image: "https://images.unsplash.com/photo-1497935586351-b67a49e012bf?w=600&q=80",
        available: 40,
        certification: "Rainforest Alliance",
        farmId: "GUJI-004",
        harvestDate: "2024-02-20",
        batchId: "BATCH-GUJI-2024-004",
        nftId: "NFT-GUJI-004",
        authenticityVerified: true
    },
    {
        id: 5,
        farmerName: "Limu Coffee Growers",
        productName: "Limu Washed Coffee Beans",
        category: "Coffee",
        origin: "Ethiopia - Limu Region",
        processingMethod: "Washed",
        qualityLevel: "Premium",
        description: "Limu coffee known for its balanced cup with chocolate and citrus notes. Carefully processed for consistency.",
        price: "$17.50/lb",
        image: "https://images.unsplash.com/photo-1442512595331-e89e73853f31?w=600&q=80",
        available: 85,
        certification: "Organic Certified",
        farmId: "LIMU-005",
        harvestDate: "2024-03-01",
        batchId: "BATCH-LIMU-2024-005",
        nftId: "NFT-LIMU-005",
        authenticityVerified: true
    },
    
    // Grains (5 items)
    {
        id: 6,
        farmerName: "Arsi Wheat Farmers Cooperative",
        productName: "Premium Durum Wheat",
        category: "Grains",
        origin: "Ethiopia - Arsi Region",
        processingMethod: "Milled",
        qualityLevel: "Premium",
        description: "High-quality durum wheat perfect for pasta and bread making. Grown in the fertile highlands of Arsi region.",
        price: "$8.50/50kg",
        image: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=600&q=80",
        available: 200,
        certification: "Organic Certified",
        farmId: "ARSI-WHEAT-001",
        harvestDate: "2024-03-15",
        batchId: "BATCH-WHEAT-2024-001",
        nftId: "NFT-WHEAT-001",
        authenticityVerified: true
    },
    {
        id: 7,
        farmerName: "Bale Highlands Rice Farmers",
        productName: "Ethiopian Jasmine Rice",
        category: "Grains",
        origin: "Ethiopia - Bale Highlands",
        processingMethod: "Polished",
        qualityLevel: "Grade 1",
        description: "Fragrant jasmine rice grown organically in mountain valleys. Long grain with natural aroma.",
        price: "$12.00/25kg",
        image: "https://images.unsplash.com/photo-1586201375761-83865001e31c?w=600&q=80",
        available: 150,
        certification: "Organic Certified",
        farmId: "BALE-RICE-002",
        harvestDate: "2024-04-01",
        batchId: "BATCH-RICE-2024-002",
        nftId: "NFT-RICE-002",
        authenticityVerified: true
    },
    {
        id: 8,
        farmerName: "Gambella Maize Farmers",
        productName: "White Maize Grain",
        category: "Grains",
        origin: "Ethiopia - Gambella Region",
        processingMethod: "Dried",
        qualityLevel: "Grade 2",
        description: "Quality white maize for flour and animal feed. Non-GMO variety grown sustainably.",
        price: "$6.00/50kg",
        image: "https://images.unsplash.com/photo-1603048588665-791ca8aea617?w=600&q=80",
        available: 300,
        certification: "Fair Trade",
        farmId: "GAMBELLA-MAIZE-003",
        harvestDate: "2024-03-20",
        batchId: "BATCH-MAIZE-2024-003",
        nftId: "NFT-MAIZE-003",
        authenticityVerified: true
    },
    {
        id: 9,
        farmerName: "Tigray Teff Cooperative",
        productName: "Brown Teff Grain",
        category: "Grains",
        origin: "Ethiopia - Tigray Region",
        processingMethod: "Cleaned",
        qualityLevel: "Premium",
        description: "Traditional Ethiopian teff grain, gluten-free superfood. Rich in iron and calcium.",
        price: "$15.00/10kg",
        image: "https://images.unsplash.com/photo-1612929633738-8fe44f91e94c?w=600&q=80",
        available: 120,
        certification: "Organic Certified",
        farmId: "TIGRAY-TEFF-004",
        harvestDate: "2024-02-28",
        batchId: "BATCH-TEFF-2024-004",
        nftId: "NFT-TEFF-004",
        authenticityVerified: true
    },
    {
        id: 10,
        farmerName: "Shewa Barley Farmers",
        productName: "Highland Barley",
        category: "Grains",
        origin: "Ethiopia - Shewa Highlands",
        processingMethod: "Hulled",
        qualityLevel: "Grade 1",
        description: "Premium barley grown at high altitude. Excellent for brewing and cooking.",
        price: "$7.50/50kg",
        image: "https://images.unsplash.com/photo-1595855759920-86582396756c?w=600&q=80",
        available: 180,
        certification: "Organic",
        farmId: "SHEWA-BARLEY-005",
        harvestDate: "2024-03-10",
        batchId: "BATCH-BARLEY-2024-005",
        nftId: "NFT-BARLEY-005",
        authenticityVerified: true
    },

    // Fruits (5 items)
    {
        id: 11,
        farmerName: "Konso Banana Growers",
        productName: "Organic Bananas",
        category: "Fruits",
        origin: "Ethiopia - Konso Region",
        processingMethod: "Fresh",
        qualityLevel: "Premium",
        description: "Sweet and creamy bananas grown in rich volcanic soil. Perfect ripeness guaranteed.",
        price: "$3.50/kg",
        image: "https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=600&q=80",
        available: 250,
        certification: "Organic Certified",
        farmId: "KONSO-BANANA-001",
        harvestDate: "2024-05-01",
        batchId: "BATCH-BANANA-2024-001",
        nftId: "NFT-BANANA-001",
        authenticityVerified: true
    },
    {
        id: 12,
        farmerName: "Oromia Mango Farmers",
        productName: "Alphonso Mangoes",
        category: "Fruits",
        origin: "Ethiopia - Oromia Region",
        processingMethod: "Fresh",
        qualityLevel: "Premium",
        description: "Juicy Alphonso mangoes with rich flavor and aroma. Handpicked at peak ripeness.",
        price: "$5.00/kg",
        image: "https://images.unsplash.com/photo-1553279768-865429fa0078?w=600&q=80",
        available: 180,
        certification: "Organic",
        farmId: "OROMIA-MANGO-002",
        harvestDate: "2024-04-25",
        batchId: "BATCH-MANGO-2024-002",
        nftId: "NFT-MANGO-002",
        authenticityVerified: true
    },
    {
        id: 13,
        farmerName: "Rift Valley Citrus Cooperative",
        productName: "Valencia Oranges",
        category: "Fruits",
        origin: "Ethiopia - Rift Valley",
        processingMethod: "Fresh",
        qualityLevel: "Grade 1",
        description: "Sweet Valencia oranges bursting with vitamin C. Grown without pesticides.",
        price: "$4.00/kg",
        image: "https://images.unsplash.com/photo-1547514701-42782101795e?w=600&q=80",
        available: 200,
        certification: "Organic Certified",
        farmId: "RIFT-ORANGE-003",
        harvestDate: "2024-04-15",
        batchId: "BATCH-ORANGE-2024-003",
        nftId: "NFT-ORANGE-003",
        authenticityVerified: true
    },
    {
        id: 14,
        farmerName: "Southern Nations Avocado Farm",
        productName: "Hass Avocados",
        category: "Fruits",
        origin: "Ethiopia - SNNPR",
        processingMethod: "Fresh",
        qualityLevel: "Premium",
        description: "Creamy Hass avocados rich in healthy fats. Perfect for salads and smoothies.",
        price: "$6.50/kg",
        image: "https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?w=600&q=80",
        available: 140,
        certification: "Organic",
        farmId: "SNNPR-AVOCADO-004",
        harvestDate: "2024-04-20",
        batchId: "BATCH-AVOCADO-2024-004",
        nftId: "NFT-AVOCADO-004",
        authenticityVerified: true
    },
    {
        id: 15,
        farmerName: "Jimma Papaya Growers",
        productName: "Golden Papayas",
        category: "Fruits",
        origin: "Ethiopia - Jimma Zone",
        processingMethod: "Fresh",
        qualityLevel: "Premium",
        description: "Sweet golden papayas rich in vitamins and enzymes. Excellent for digestion.",
        price: "$4.50/kg",
        image: "https://images.unsplash.com/photo-1617112848923-cc2234396a8d?w=600&q=80",
        available: 160,
        certification: "Organic Certified",
        farmId: "JIMMA-PAPAYA-005",
        harvestDate: "2024-04-28",
        batchId: "BATCH-PAPAYA-2024-005",
        nftId: "NFT-PAPAYA-005",
        authenticityVerified: true
    },

    // Vegetables (5 items)
    {
        id: 16,
        farmerName: "Addis Organic Vegetable Farm",
        productName: "Fresh Tomatoes",
        category: "Vegetables",
        origin: "Ethiopia - Addis Ababa",
        processingMethod: "Fresh",
        qualityLevel: "Premium",
        description: "Vine-ripened organic tomatoes. Rich flavor perfect for salads and cooking.",
        price: "$2.50/kg",
        image: "https://images.unsplash.com/photo-1546470427-227fc2d2f19e?w=600&q=80",
        available: 300,
        certification: "Organic Certified",
        farmId: "ADDIS-TOMATO-001",
        harvestDate: "2024-05-05",
        batchId: "BATCH-TOMATO-2024-001",
        nftId: "NFT-TOMATO-001",
        authenticityVerified: true
    },
    {
        id: 17,
        farmerName: "Bahir Dar Onion Farmers",
        productName: "Red Onions",
        category: "Vegetables",
        origin: "Ethiopia - Bahir Dar",
        processingMethod: "Cured",
        qualityLevel: "Grade 1",
        description: "Crisp red onions with mild sweet flavor. Long storage life guaranteed.",
        price: "$1.80/kg",
        image: "https://images.unsplash.com/photo-1580201092675-a0a6a4a39b91?w=600&q=80",
        available: 400,
        certification: "Fair Trade",
        farmId: "BAHIR-ONION-002",
        harvestDate: "2024-04-10",
        batchId: "BATCH-ONION-2024-002",
        nftId: "NFT-ONION-002",
        authenticityVerified: true
    },
    {
        id: 18,
        farmerName: "Harar Cabbage Cooperative",
        productName: "Green Cabbage",
        category: "Vegetables",
        origin: "Ethiopia - Harar",
        processingMethod: "Fresh",
        qualityLevel: "Premium",
        description: "Crisp green cabbage packed with nutrients. Perfect for salads and fermentation.",
        price: "$1.50/kg",
        image: "https://images.unsplash.com/photo-1594282801141-1347ce730f43?w=600&q=80",
        available: 350,
        certification: "Organic",
        farmId: "HARAR-CABBAGE-003",
        harvestDate: "2024-05-03",
        batchId: "BATCH-CABBAGE-2024-003",
        nftId: "NFT-CABBAGE-003",
        authenticityVerified: true
    },
    {
        id: 19,
        farmerName: "Gonder Carrot Farm",
        productName: "Orange Carrots",
        category: "Vegetables",
        origin: "Ethiopia - Gonder Region",
        processingMethod: "Fresh",
        qualityLevel: "Grade 1",
        description: "Sweet crunchy carrots high in beta-carotene. Grown in mineral-rich soil.",
        price: "$2.00/kg",
        image: "https://images.unsplash.com/photo-1598170845058-32b9d6a5da37?w=600&q=80",
        available: 280,
        certification: "Organic Certified",
        farmId: "GONDER-CARROT-004",
        harvestDate: "2024-05-02",
        batchId: "BATCH-CARROT-2024-004",
        nftId: "NFT-CARROT-004",
        authenticityVerified: true
    },
    {
        id: 20,
        farmerName: "Debre Zeit Lettuce Growers",
        productName: "Romaine Lettuce",
        category: "Vegetables",
        origin: "Ethiopia - Debre Zeit",
        processingMethod: "Fresh",
        qualityLevel: "Premium",
        description: "Crispy romaine lettuce grown hydroponically. Pesticide-free and fresh.",
        price: "$3.00/kg",
        image: "https://images.unsplash.com/photo-1622206151226-18ca2c9ab4a1?w=600&q=80",
        available: 220,
        certification: "Organic",
        farmId: "DEBRE-LETTUCE-005",
        harvestDate: "2024-05-06",
        batchId: "BATCH-LETTUCE-2024-005",
        nftId: "NFT-LETTUCE-005",
        authenticityVerified: true
    },

    // Spices (3 items)
    {
        id: 21,
        farmerName: "Yirgalem Spice Farmers",
        productName: "Korarima (Ethiopian Cardamom)",
        category: "Spices",
        origin: "Ethiopia - Yirgalem",
        processingMethod: "Dried",
        qualityLevel: "Premium",
        description: "Aromatic Ethiopian cardamom with unique flavor profile. Essential for traditional cooking.",
        price: "$25.00/kg",
        image: "https://images.unsplash.com/photo-1596040033229-a0b10dc05c40?w=600&q=80",
        available: 50,
        certification: "Organic Certified",
        farmId: "YIRGA-KORARIMA-001",
        harvestDate: "2024-03-25",
        batchId: "BATCH-KORARIMA-2024-001",
        nftId: "NFT-KORARIMA-001",
        authenticityVerified: true
    },
    {
        id: 22,
        farmerName: "Bonga Turmeric Cooperative",
        productName: "Fresh Turmeric Root",
        category: "Spices",
        origin: "Ethiopia - Bonga Forest",
        processingMethod: "Fresh",
        qualityLevel: "Premium",
        description: "High curcumin content turmeric with anti-inflammatory properties. Bright orange color.",
        price: "$8.00/kg",
        image: "https://images.unsplash.com/photo-1615485500134-275207574502?w=600&q=80",
        available: 90,
        certification: "Organic",
        farmId: "BONGA-TURMERIC-002",
        harvestDate: "2024-04-18",
        batchId: "BATCH-TURMERIC-2024-002",
        nftId: "NFT-TURMERIC-002",
        authenticityVerified: true
    },
    {
        id: 23,
        farmerName: "Metema Ginger Farm",
        productName: "Organic Ginger Root",
        category: "Spices",
        origin: "Ethiopia - Metema",
        processingMethod: "Fresh",
        qualityLevel: "Grade 1",
        description: "Spicy fresh ginger with intense flavor. Perfect for teas, cooking, and wellness.",
        price: "$6.50/kg",
        image: "https://images.unsplash.com/photo-1599894823941-1255b4f8feaf?w=600&q=80",
        available: 110,
        certification: "Organic Certified",
        farmId: "METEMA-GINGER-003",
        harvestDate: "2024-04-22",
        batchId: "BATCH-GINGER-2024-003",
        nftId: "NFT-GINGER-003",
        authenticityVerified: true
    },

    // Dairy & Bee Products (3 items)
    {
        id: 24,
        farmerName: "Oromia Honey Producers Union",
        productName: "Wild Forest Honey",
        category: "Dairy & Bee Products",
        origin: "Ethiopia - Oromia Forest",
        processingMethod: "Raw",
        qualityLevel: "Premium",
        description: "Pure wild forest honey collected from traditional beehives. Rich in antioxidants and natural enzymes.",
        price: "$12.00/500g",
        image: "https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=600&q=80",
        available: 80,
        certification: "Fair Trade Certified",
        farmId: "OROMIA-HONEY-001",
        harvestDate: "2024-02-28",
        batchId: "BATCH-HONEY-2024-001",
        nftId: "NFT-HONEY-001",
        authenticityVerified: true
    },
    {
        id: 25,
        farmerName: "Borana Dairy Cooperative",
        productName: "Fresh Cow Milk",
        category: "Dairy & Bee Products",
        origin: "Ethiopia - Borana Zone",
        processingMethod: "Pasteurized",
        qualityLevel: "Grade 1",
        description: "Fresh pasteurized cow milk from grass-fed cattle. Rich and creamy taste.",
        price: "$2.50/liter",
        image: "https://images.unsplash.com/photo-1563636619-e9143da7973b?w=600&q=80",
        available: 200,
        certification: "Organic",
        farmId: "BORANA-MILK-002",
        harvestDate: "2024-05-07",
        batchId: "BATCH-MILK-2024-002",
        nftId: "NFT-MILK-002",
        authenticityVerified: true
    },
    {
        id: 26,
        farmerName: "Tigray Beeswax Producers",
        productName: "Pure Beeswax",
        category: "Dairy & Bee Products",
        origin: "Ethiopia - Tigray Region",
        processingMethod: "Filtered",
        qualityLevel: "Premium",
        description: "Natural beeswax for candles, cosmetics, and crafts. Chemical-free and pure.",
        price: "$18.00/kg",
        image: "https://images.unsplash.com/photo-1595857505219-fa72872b9e93?w=600&q=80",
        available: 60,
        certification: "Organic Certified",
        farmId: "TIGRAY-BEESWAX-003",
        harvestDate: "2024-03-15",
        batchId: "BATCH-BEESWAX-2024-003",
        nftId: "NFT-BEESWAX-003",
        authenticityVerified: true
    },

    // Livestock (2 items)
    {
        id: 27,
        farmerName: "Afar Livestock Cooperative",
        productName: "Grass-Fed Cattle",
        category: "Livestock",
        origin: "Ethiopia - Afar Region",
        processingMethod: "Live",
        qualityLevel: "Premium",
        description: "Healthy grass-fed cattle raised in open pastures. Excellent meat quality.",
        price: "$1,200/head",
        image: "https://images.unsplash.com/photo-1516467508483-a7212febe31a?w=600&q=80",
        available: 15,
        certification: "Organic",
        farmId: "AFAR-CATTLE-001",
        harvestDate: "2024-01-01",
        batchId: "BATCH-CATTLE-2024-001",
        nftId: "NFT-CATTLE-001",
        authenticityVerified: true
    },
    {
        id: 28,
        farmerName: "Somali Goat Farmers",
        productName: "Healthy Goats",
        category: "Livestock",
        origin: "Ethiopia - Somali Region",
        processingMethod: "Live",
        qualityLevel: "Grade 1",
        description: "Hardy goats adapted to arid climates. Good for meat and milk production.",
        price: "$180/head",
        image: "https://images.unsplash.com/photo-1542838309-3a59b2b6cd26?w=600&q=80",
        available: 40,
        certification: "Fair Trade",
        farmId: "SOMALI-GOAT-002",
        harvestDate: "2024-01-01",
        batchId: "BATCH-GOAT-2024-002",
        nftId: "NFT-GOAT-002",
        authenticityVerified: true
    }
];

export default mockProducts;
